<template>
  <div class="mult-input">
    <!-- 编辑状态 -->
    <div class="mult-list" v-if="dataList.length">
      <div
        class="mult-item"

        v-for="(item, index) in dataList"
        :key="getKey(item, index)"
        :data-key="getKey(item, index)"
      >
      <van-popover v-model="item.showPopover" @select="selectTool" trigger="click" :offset="[16,22]" 
        :actions="index===0&&dataList.length>1?actionsDown:index>0&&index===dataList.length-1?actionsUp:dataList.length===1?actionsDel:actions" placement="bottom-end" >
        <template #reference>
          <div class="item-tool" @click="()=>{
            selectIndex=index;
          }">
              <!-- <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00129.png"/> -->
          </div>
        </template>
      </van-popover> 
        <!-- 编辑状态下的操作图标 -->
        <!-- <div class="mu-icons">
          <svg
            v-if="index < list.length - 1"
            class="vxm-icon mu-down"
            aria-hidden="true"
            @click="sort('down', index)"
          >
            <use xlink:href="#vxm-icon-system_down_2"></use>
          </svg>
          <svg
            v-if="index > 0"
            class="vxm-icon mu-up"
            aria-hidden="true"
            @click="sort('up', index)"
          >
            <use xlink:href="#vxm-icon-system_up_2"></use>
          </svg>
          <svg class="vxm-icon mu-del" aria-hidden="true" @click="dele(index)">
            <use xlink:href="#vxm-icon-system_close"></use>
          </svg>
        </div> -->

        <!-- 文本 -->
        <van-field
          v-if="item.type === 'text' && (enableText||showText)"
          class="text"
          input-align="left"
          v-model="item.content"
          rows="4"
          autosize
          type="textarea"
          maxlength="1000"
          placeholder="请输入"
          show-word-limit
        />

        
        <!-- 文本 -->
        <div
        class='aitext'
        v-else-if="item.type === 'aitext' && enableAiText"
        >
          <van-field
          class="text"
          input-align="left"
          v-model="item.content"
          rows="4"
          autosize
          type="textarea"
          :readonly="item.disabled"
          maxlength="1000"
          :placeholder="aiTextPlaceholder"
          />
          <div class="tool">
            <div class="left">
              <div class="clear" @click="clearAIText(index)">清空</div>
              <div class="set-back" v-show="item.showBack" @click="setBack(index)">还原</div>
            </div>
            <div class="ai">
              <div class="pbjc" @click="pbjc(index)">排版纠错</div>
              <div class="aiwhrite" @click="aiWhrite(index)">AI生成</div>  
            </div>
          </div>
        </div>
        


        <!-- 图片展示 -->
        <!-- lazy-load -->
        <div class="img flex-center" v-else-if="item.type === 'image'">
          <van-image class="vimg" fit="scale-down" alt="" :src="item.url" @click="previewImg(item)">
            <template v-slot:loading>
              <van-loading type="circular" vertical size="20">加载中...</van-loading>
            </template>
          </van-image>
        </div>

        <!-- 视频展示 -->
        <!-- <div
          class="video flex-center"
          v-else-if="item.type === 'video'"
          @touchstart="app.module.video.setSrc(item.url)"
          @mousedown="app.module.video.setSrc(item.url)"
          @click="app.module.video.play"
        >
          <van-image
            class="vimg"
            fit="scale-down"
            alt=""
            :src="getVideoThumbUrl(item)"
            @touchstart="app.module.video.setSrc(item.url)"
            @mousedown="app.module.video.setSrc(item.url)"
            @click="app.module.video.play"
          >
            <template v-slot:loading>
              <van-loading type="circular" vertical size="20">加载中...</van-loading>
            </template>
          </van-image>
          <div class="pay-icon-warp">
            <van-icon class-prefix="vxs-icon" name="bofang" size="75" color="#FFF" />
          </div>
        </div> -->

        <!-- 视频展示 西瓜视频 -->
        <div
          class="video flex-center"
          v-else-if="item.type === 'video'"
          @click="app.module.video.play(item.url)"
        >
          <van-image class="vimg" fit="cover" alt="" :src="getVideoThumbUrl(item)">
            <template v-slot:loading>
              <van-loading type="circular" vertical size="20">加载中...</van-loading>
            </template>
          </van-image>
          <div class="pay-icon-warp">
            <!-- <van-icon class-prefix="vxs-icon" name="bofang" size="75" color="#FFF" /> -->
            <div class="to-play-icon"></div>
          </div>
        </div>
        
        <!-- 精彩瞬间展示 西瓜视频 -->
        <template v-else-if="item.type === 'moment'">
          <!-- 已经有视频的url地址 -->
          <div
            class="video flex-center"
            v-if="item.url"
            @click="app.module.video.play(item.url)"
          >
            <van-image class="vimg" fit="cover" alt="" :src="getVideoThumbUrl(item)">
              <template v-slot:loading>
                <van-loading type="circular" vertical size="20">加载中...</van-loading>
              </template>
            </van-image>
            <div class="pay-icon-warp">
              <!-- <van-icon class-prefix="vxs-icon" name="bofang" size="75" color="#FFF"/> -->
              <div class="to-play-icon"></div>
            </div>
          </div>
          <!-- 一键生成视频or合成中视频：暂无视频的url地址 -->
          <div class="video-default" v-else>
            <div class="txt flex-center"><van-loading color="var(--c1)" size="18"/>视频合成中...</div>
            <div class="desc">若此时提交点评，该点评将在视频合成后自动发送</div>
          </div>
        </template>

        <!-- 语音展示 -->
        <multimedia-record v-else-if="item.type === 'audio'" :record="item"></multimedia-record>
      </div>
    </div>

    <!-- 工具条 控件 -->
    <div class="toolbar">
      <div class="tool" @click="addText" v-if="enableText">
        <svg class="vxm-icon" aria-hidden="true">
          <use xlink:href="#vxm-icon-tianjiawenzi"></use>
        </svg>
        <div class="text">文本</div>
      </div>

      <div class="tool" @click="addAiText" v-if="enableAiText">
        <svg class="vxm-icon" aria-hidden="true">
          <use xlink:href="#vxm-icon-bianzu4"></use>
        </svg>
        <div class="text">AI文本</div>
      </div>

      <div class="tool" v-if="imgCounts < imgMax">
        <svg class="vxm-icon" aria-hidden="true">
          <use xlink:href="#vxm-icon-tianjiatupian"></use>
        </svg>
        <div class="text">图片</div>
        <div v-if="app.base.env == 'xgj'" class="up-btn" @click="addImg"></div>
        <van-uploader
          v-else
          class="up-btn"
          accept="image/*"
          :multiple="isAndroid?false:true"
          result-type="file"
          :after-read="addImg_H5"
          upload-text="上传文字提示"
        />
      </div>

      <div class="tool" v-if="showVideoBtn">
        <svg class="vxm-icon" aria-hidden="true">
          <use xlink:href="#vxm-icon-tianjiashipin"></use>
        </svg>
        <div class="text">视频</div>
        <div v-if="app.base.env == 'xgj'" class="up-btn" @click="addVideo"></div>
        <van-uploader
          v-else
          class="up-btn"
          accept="video/*"
          multiple
          result-type="file"
          :after-read="addVideo_H5"
          :max-size="maxSize * 1024 * 1024"
          @oversize="oversize"
          upload-text="上传文字提示"
        />
      </div>

      <div class="tool" v-if="showAudioBtn" @click="addVioce">
        <svg class="vxm-icon" aria-hidden="true">
          <use xlink:href="#vxm-icon-tianjiayuyin"></use>
        </svg>
        <div class="text">录音</div>
      </div>

      <slot name="moment"></slot>
    </div>


  <van-popup v-model="showAiPopup" class="ai-popup" :safe-area-inset-bottom="true"  get-container="body" :close-on-popstate="true" round position="bottom" :style="{ height: '80%' }" >
    <div class="header">
      <div class="title" v-if="aiParam.code!=='AI_TEXT_CONTROL_CORRECT'">{{actionnl.filter(v=>v.value===aiParam.code)[0].name||'AI生成'}}</div>
      <div class="close" @click="closeAiPopup">
        <van-icon name="cross" />
      </div>
    </div>
    <div class="aiMessage" v-if="tokenWarn_state">
      <span @click.stop="routerAiMoney">AI算力剩余{{remainTokenNum}}，为了保证功能正常使用，请尽快充值</span>
    </div>
    <div class="content-list" :class="tokenWarn_state ? 'content-list-active' : ''" ref="contentId">
        <div class="content-item" v-for="(item,index) in aiResults" :key="item.id">
          <div class="content-header">
            <div class="icon">
              <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00126.png" mode="aspectFill"/>
            </div>
            <div class="num">#{{index+1<10?'0'+(index+1):index+1 }}</div>
          </div>
          <div class="content-text">
            <van-field
              class="text"
              input-align="left"
              v-model="item.text"
              rows="4"
              autosize
              readonly
              type="textarea"
            />
          </div>
          <div class="content-tool">
            <div v-show="item.aipending" class="stop" @click="closeAiServer(index)">
              <!-- <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00132.png" mode="aspectFill"/>
               -->
               <svg class="vxm-icon" aria-hidden="true">
                <use xlink:href="#vxm-icon-tingzhi"></use>
              </svg>
              停止
            </div>
            <div class="clear" v-show="!item.aipending" style="opacity:0">
              <!-- @click="()=>{aiResults.splice(index,1)}" -->
              <!-- <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00127.png" mode="aspectFill"/> -->
            </div>
            <div class="select-use" v-show="!item.aipending" @click="selectUseAIresult(item,index)">选择使用</div>
          </div>
        </div>
    </div>

    <div class="ai-param" id="ai-param-id" :style="showIdea?'height:56px;opacity:1;':''" >
      <!-- 能力 -->
      <div :class="selectAIParamActives.includes('nl')?'item ai-nl select-active':'item ai-nl'" @click="selectAIParam('nl')">
        {{actionnl.some(v=>v.value===aiParam.code)?actionnl.filter(v=>v.value===aiParam.code)[0].name:'AI能力'}} <van-icon name="play" />
      </div>
      <!-- 语气 -->
      <div 
      v-show="aiParam.code!=='AI_TEXT_CONTROL_SIMPLIFY'"
      :class="
      selectAIParamActives.includes('manner')?
      'item ai-manner select-active'
      :'item ai-manner'
      " @click="selectAIParam('manner')">
        {{actionsmanner.some(v=>v.value===aiParam.dict.tone)?actionsmanner.filter(v=>v.value===aiParam.dict.tone)[0].name:'语气'}} <van-icon name="play" />
      </div>
      <!-- 字数 -->
      <div v-show="aiParam.code==='AI_TEXT_CONTROL_EXTEND'"
       :class="selectAIParamActives.includes('count')?'item ai-count select-active'
       :'item ai-count'
       " @click="selectAIParam('count')">
        {{actionscount.some(v=>v.value===aiParam.dict.wordCount)?actionscount.filter(v=>v.value===aiParam.dict.wordCount)[0].name+'字':'字数'}}  <van-icon name="play" />
      </div>

      <div :class="selectAIParamActives.includes('emoji')?'item ai-emoji select-active-banner':'item ai-emoji'" @click="selectAIParam('emoji')">
        包含表情
      </div>
    </div>
    <div class="ai-tool">
      <div :class="{more:true,active:showIdea}" @click="openIdea" id="ai-more">
        <svg class="vxm-icon" aria-hidden="true">
          <use xlink:href="#vxm-icon-xiangfa"></use>
        </svg>
        <!-- <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00128.png" mode="aspectFill"/> -->
        <span>想法</span>
      </div>
      <van-button color="var(--c1)" class="product" type="primary" :disabled="aiPendingLoading" @click="aiAgain">{{aiPendingLoading?'生成中...':'再次生成'}}</van-button>
    </div>
  </van-popup>


  <van-action-sheet
    id="nl-id"
    @click-overlay="overlayClick"
    v-model="shownl"
    :actions="actionnl"
    get-container="body"
    cancel-text="取消"
    description="选择AI能力"
    close-on-click-action
    @closed="closeAction('nl')"
    @select="selectActionnl"
  />

  <van-action-sheet
  id="manner-id"
    v-model="showmanner"
    get-container="body"
    :actions="actionsmanner"
    cancel-text="取消"
    description="选择语气"
    close-on-click-action
    @closed="closeAction('manner')"
    @select="selectActionmanner"
  />

  <van-action-sheet
  id="count-id"
    v-model="showcount"
    :actions="actionscount"
    cancel-text="取消"
    description="选择字数"
    close-on-click-action
    get-container="body"
    @closed="closeAction('count')"
    @select="selectActioncount"
  />

  </div>

</template>

<script>
import MultimediaRecord from './child/multimedia-record.vue';
import { detectFileType } from '../../../js/tool/file-detect.js';

let defaultConfig = {
  // 最多可添加多少条文本
  textMax: 20,
  // 单条文本最多可录多少字符
  textLength: 1000,
  // 最多可添加多少张图片
  imgMax: 9,
  // 最多可添加多少条语音
  audioMax: 9,
};

export default {
  name: 'vx-multInput',
  components: {
    MultimediaRecord,
  },
  model: {
    prop: 'list',
    event: 'change',
  },
  props: {
    //   接一传入数据
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 是否开启文本
    enableText: {
      type: Boolean,
      default: true,
    },
    // 是否开启文本
    showText: {
      type: Boolean,
      default: false,
    },
    // 是否开启文本
    enableAiText: {
      type: Boolean,
      default: false,
    },
    aiTextPlaceholder:{
      type:String,
      default:'请输入'
    },
    // 是否开启录音
    enableAudio: {
      type: Boolean,
      default: false,
    },
    // 是否开启视频
    enableVideo: {
      type: Boolean,
      default: false,
    },
    // H5能力下，视频最大大小,单位MB;
    maxSize: {
      type: Number,
      default: 200,
    },
    // 原生能力下，视频最大时长,单位秒;
    maxDuration: {
      type: Number,
      default: 600,
    },
    imgMax: {
      type: Number,
      default: 100,
    },
    aiRemaining: {
      type: Boolean,
      default: true,
    },
    remainTokenNum: {
      type: String,
      default: ''
    },
    tokenWarn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showIdea:false,
      actions: [
        { text: '上移', icon: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00130.png',id:1 },
        { text: '下移', icon: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00131.png',id:2 },
        { text: '删除', icon: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00127.png',id:3 },
      ],
      actionsDown: [
        { text: '下移', icon: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00131.png',id:2 },
        { text: '删除', icon: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00127.png',id:3 },
      ],
      actionsUp: [
        { text: '上移', icon: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00130.png',id:1 },
        { text: '删除', icon: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00127.png',id:3 },
      ],
      actionsDel:[
        { text: '删除', icon: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00127.png',id:3 },
      ],
      aiResults:[],
      showAiPopup:false,
      dataList: [],
      currentAiIndex:0,
      xgj_version: '',
      isAndroid: app.base.isAndroid,
      webscoket:null,
      selectIndex:0,
      selectAIParamActives:['emoji'],
      // 能力
      actionnl:[
        {name:'内容润色',value:'AI_TEXT_CONTROL_POLISH'},
        {name:'内容扩写',value:'AI_TEXT_CONTROL_EXTEND'},
        {name:'内容精简',value:'AI_TEXT_CONTROL_SIMPLIFY'},
      ],
      // 语气
      actionsmanner:[
        // {name:'专业',value:'专业'},
        // {name:'日常',value:'日常'},
        // {name:'坦诚',value:'坦诚'},
        // {name:'自信',value:'自信'},
        // {name:'友好',value:'友好'},
        {name:'平和',value:'平和'},
        {name:'严肃',value:'严肃'},
        {name:'鼓励',value:'鼓励'},
      ],
      // 字数
      actionscount:[
        {name:'100',value:'100'},
        {name:'200',value:'200'},
        {name:'300',value:'300'},
        {name:'500',value:'500'},
        // {name:'800',value:'800'},
      ],
      // ai参数
      aiParam:{
        productCode:1,
        code:'AI_TEXT_CONTROL_EXTEND',
        message:'',
        dict:{
          wordCount:'200',
          tone:'鼓励',
          emoji:"添加"
        }
      },
      lastCode:'',
      // 显示能力的actionsheet
      shownl:false,
      // 显示语气的actionsheet
      showmanner:false,
      // 显示字数的actionsheet
      showcount:false,
      aipending:false,
    };
  },
  computed: {
    // 等APP做好升级功能后，可以只用'enableVideo'配置项决定
    showVideoBtn() {
      if (app.base.env == 'xgj') {
        return this.enableVideo && this.xgj_version;
      } else {
        return this.enableVideo;
      }
    },
    showAudioBtn() {
      if (app.base.env == 'xgj') {
        return this.enableAudio && this.xgj_version;
      } else {
        return this.enableAudio;
      }
    },
    imgCounts(){
      return this.dataList.filter(item=>item.type == 'image').length
    },
    aiPendingLoading(){
      return this.aiResults.some(v=>v.aipending)
    },
    tokenWarn_state() {
      return this.tokenWarn
    }
  },
  methods: {
    colseImage() {
      // 预警状态
      this.tokenWarn_state = false
    },
    routerAiMoney() {
      // 跳转到去充值页面
      app.teacher.gotoOpenBuyAI();
    },
    selectUseAIresult(item,i){
      console.log(item )
      this.dataList[this.currentAiIndex].content=item.text;
      this.showAiPopup=false
      try {
        // 谷歌分析
        gtag('event', 'x3-event-button', {
          x3_env: process.env.VUE_APP_x3_env,
          x3_app_type: 'x3-老师端',
          x3_client_type: app.base.env,
          x3_company_name: app.teacher.user.companyInfoVo.companyName||`机构名称为空${app.teacher.user.companyInfoVo.id}`,
          x3_teacher_name:app.teacher.user.name||`老师名称为空${app.teacher.user.id}`,
          x3_teacher_campus_name:app.teacher.campus.name||`校区名称为空${app.teacher.campus.id}`,
          x3_ai_menu_name: `课堂点评-选择第${i+1}条`,
          x3_count:item.text.length,
          ai_code:item.param.code,
          ai_emoji:item.param.dict.emoji,
          ai_tone:item.param.dict.tone,
          ai_wordCount:item.param.dict.wordCount,
          ai_message:item.param.message,
          x3_click_time:new Date().getTime(),
        });  
      } catch (error) {
        console.error(error)
        // 谷歌分析
        gtag('event', 'x3-event-button', {
          x3_env: process.env.VUE_APP_x3_env,
          x3_app_type: 'x3-老师端',
          x3_client_type: app.base.env,
          x3_company_name: app.teacher.user.companyInfoVo.companyName||`机构名称为空${app.teacher.user.companyInfoVo.id}`,
          x3_teacher_name:app.teacher.user.name||`老师名称为空${app.teacher.user.id}`,
          x3_teacher_campus_name:app.teacher.campus.name||`校区名称为空${app.teacher.campus.id}`,
          x3_ai_menu_name: `课堂点评-选择第${i+1}条`,
          message:JSON.stringify(error||{}),
          x3_click_time:new Date().getTime(),
        });
      }
      
    },
    closeAiServer(index=this.aiResults.length-1){
      if(this.aiResults&&this.aiResults[index]){
        this.aiResults[index].aipending=false;
      }
      this.webscoket&&this.webscoket.close();
    },
    closeAction(key){
      this.selectAIParamActives.splice(this.selectAIParamActives.findIndex(v=>v===key),1);
    },
    selectActionnl(e){
      this.aiParam.code=e.value;
      this.setAiParam();
    },
    setAiParam(){
      // this.lastCode=this.aiParam.code;
      app.ls.setStorage('ai-param-save',JSON.stringify(this.aiParam));
    },
    getAiParam(){
      return app.ls.get('ai-param-save')?JSON.parse(app.ls.get('ai-param-save')):{
        productCode:1,
        code:'AI_TEXT_CONTROL_EXTEND',
        message:'',
        dict:{
          wordCount:'200',
          tone:'鼓励',
          emoji:"添加"
        }
      };
    },
    selectActionmanner(e){
      this.aiParam.dict.tone=e.value;
      this.setAiParam();
    },
    selectActioncount(e){
      this.aiParam.dict.wordCount=e.value
      this.setAiParam();
    },
    selectAIParam(key){
      if(!this.selectAIParamActives.includes(key)){
        if(key==='nl'){
          this.shownl=true;
        }else if(key==='manner'){
          this.showmanner=true;
        }else if(key==='count'){
          this.showcount=true;
        }
        this.selectAIParamActives.push(key);
        if(key==='emoji'){
          this.aiParam.dict.emoji='添加';
          this.setAiParam();
        }
      }else{
        if(key==='nl'){
          this.shownl=false;
        }else if(key==='manner'){
          this.showmanner=false;
        }else if(key==='count'){
          this.showcount=false;
        }
        this.selectAIParamActives.splice(this.selectAIParamActives.findIndex(v=>v===key),1);
        if(key==='emoji'){
          this.aiParam.dict.emoji='不添加'
          this.setAiParam();
        }
      }
    },
    selectTool(e){
      if(e.id===1){
        this.sort('up',this.selectIndex)
      }else if(e.id===2){
        this.sort('down',this.selectIndex)
      }else if(e.id===3){
        this.dele(this.selectIndex)
      }
    },
    initWebSocket(key){
      if(key!=='wrong'){
        this.aiResults[this.aiResults.length-1].aipending=true;
      }
      let url=''
      if (document.location.port) {
        const { ip } = app.tool.parseQuery();
        url= `x3-${ip||'dev'}.xiaogj.com`
      } else {
        url= window.location.host
      }
      const wsuri=`wss://${url}/api/ai-server/im/chat/ai?x3-authentication=`+app.ls.get("x3-teacher-token");
      this.webscoket=new WebSocket(wsuri);
      this.webscoket.addEventListener("open", this.handleWsOpen.bind(this), false);
      this.webscoket.addEventListener("close", this.handleWsClose.bind(this), false);
      this.webscoket.addEventListener("error", this.handleWsError.bind(this), false);
      this.webscoket.addEventListener("message", this.handleWsMessage.bind(this), false);
    },
    handleWsOpen(){
      console.log('打开连接')
      let param=JSON.parse(JSON.stringify(this.aiParam));
      if(this.lastCode){
        param.code=this.lastCode;
      }
      this.webscoket&&this.webscoket.send(JSON.stringify(param))
      // 谷歌分析
      gtag('event', 'x3-event-ai-generating', {
        x3_env: process.env.VUE_APP_x3_env,
        x3_app_type: 'x3-课堂点评AI生成',
        x3_client_type: app.base.env,
        x3_ai_menu_name: `AI生成`+`${app.teacher.user.companyInfoVo.companyName}-${app.teacher.campus.name}-${app.teacher.user.name}`,
        x3_genera_count:this.aiParam.message.length,
        ai_genera_code:this.aiParam.code,
        ai_genera_tone:this.aiParam.dict.tone,
        ai_genera_count:this.aiParam.dict.wordCount,
        ai_genera_emoji:this.aiParam.dict.emoji,
        ai_genera_message:this.aiParam.message,
        x3_genera_click_time:new Date().getTime(),
      });
    },
    handleWsClose(){
      this.$emit('getTokenUsageApi_init')
      console.log('关闭连接')
    },
    handleWsError(){
      console.log('错误连接')
    },
    handleWsMessage(e){
      const res = JSON.parse(e.data)
      if (res.code >= 300 && res.code <= 60000) {
        setTimeout(() => {
          vant.Toast(res.msg);
        }, 150);
        return
      } else {
        // 600521 机构已切换, 60001 token过期
        if (res.code === 60001) {
          // callback(null)
        }
        // 算力不足
        if (res.code === 791000001) {
          this.webscoket&&this.webscoket.close();
          this.aiConfirm(true)
          return
        }
      }
      if(res.data.code==='AI_TEXT_CONTROL_CORRECT'){
        // 如果点了还原,则暂停追加内容了
        if(this.dataList[this.currentAiIndex].showBack){
          this.dataList[this.currentAiIndex].content+=res.data.reply;
        }
      }else{
        this.aiResults[this.aiResults.length-1].text+=res.data.reply;
        // 在适当的时机执行滚动
        let _this=this;
        setTimeout(() => {
          const contentElement = _this.$refs.contentId;
          contentElement.scrollTop = contentElement.scrollHeight+99999;
          contentElement.style.transition = 'all 0.5s'; // 添加动画效果
        }, 0);
      }
      // status 2 生成已完成
      if(res.data.status===2)
      if(res.data.code!=='AI_TEXT_CONTROL_CORRECT'){
        this.aiResults[this.aiResults.length-1].aipending=false;
      }else{
        this.dataList[this.currentAiIndex].disabled=false;
      }
    },
    openIdea(){
      this.showIdea=!this.showIdea;
      let _this=this;
      let count=0;
        const contentElement = _this.$refs.contentId;
        Array.from(contentElement.children).forEach(item=>{
          count+=item.scrollHeight;
        })
        // 子item高度大于list则滚动
        if(count>contentElement.offsetHeight-32){
          contentElement.style.marginTop=this.showIdea?'-56px':'0px';
        }
        contentElement.scrollTop = contentElement.scrollHeight+99999;
        contentElement.style.transition = 'all 0.5s'; // 添加动画效果
        if(this.showIdea){
          // setTimeout(() => {
          //   const contentElement = _this.$refs.contentId;
          //   contentElement.scrollTop = contentElement.scrollHeight;
          //   contentElement.style.transition = 'transform 0.3s ease-in-out'; // 添加动画效果
          // }, 10);
        }
    },
    // 关闭ai帮写弹出
    closeAiPopup(){
      this.showAiPopup=false;
    },
    // 排版纠错
    pbjc(index){
      if (!this.aiRemaining) {
        this.aiConfirm()
        return
      }
      if(this.dataList[index].content.trim()===''){
        vant.Toast('请输入课堂评语');
      }else{
        // 如果有正在生成的就打开弹框不做处理
          this.aiParam.message=this.dataList[index].content
          if(!this.dataList[index].backText){
            this.dataList[index].backText=this.dataList[index].content;
          }
          this.dataList[index].showBack=true;
          this.dataList[index].disabled=true;
          this.currentAiIndex=index;
          this.lastCode='AI_TEXT_CONTROL_CORRECT'
          this.dataList[index].content='';
          this.closeAiServer();
          this.initWebSocket('wrong');
          // 谷歌分析
          gtag('event', 'x3-event-button', {
            x3_env: process.env.VUE_APP_x3_env,
            x3_app_type: 'x3-老师端-课堂点评',
            x3_client_type: app.base.env,
            x3_company_name: app.teacher.user.companyInfoVo.companyName||`机构名称为空${app.teacher.user.companyInfoVo.id}`,
            x3_teacher_name:app.teacher.user.name||`老师名称为空${app.teacher.user.id}`,
            x3_teacher_campus_name:app.teacher.campus.name||`校区名称为空${app.teacher.campus.id}`,
            x3_ai_menu_name: `排版纠错`,
            x3_count:this.aiParam.message.length,
            ai_code:'AI_TEXT_CONTROL_CORRECT',
            ai_message:this.aiParam.message,
            x3_click_time:new Date().getTime(),
          });
      }
    },
    // ai帮写
    aiWhrite(index){
      // console.log(this.dataList)
      if (!this.aiRemaining) {
        this.aiConfirm()
        return
      }
      if(this.dataList[index].content.trim()===''){
        this.$emit('getTokenUsageApi_init')
        vant.Toast('请输入课堂评语');
      }else{
        this.aiResults=this.dataList[index].aiResults;
        // 如果有正在生成的就打开弹框不做处理
        console.log(this.dataList)
        if(this.aiResults.some(v=>v.aipending)){
          this.showAiPopup=true;
          this.lastCode=''
        }else{
          this.lastCode=''
          this.aiParam.message=this.dataList[index].content
          this.setAiParam();
          this.showAiPopup=true;
          // 不是上次正在生成的ai文本则暂停
          if(index!==this.currentAiIndex){
            this.webscoket&&this.webscoket.close();
          }
          this.currentAiIndex=index;
          
          if(this.aiResults.length===0||this.aiParam.message.trim()!==this.dataList[index].lastContent.trim()){
            this.dataList[index].lastContent=this.aiParam.message
            this.aiResults.push({
              id:new Date().getTime(),
              text:'',
              aipending:false,
              param:this.aiParam
            })
            this.initWebSocket();

          }
        }
      }
    },
    aiConfirm(state = false) {
      const len = this.dataList.length
      vant.Dialog.confirm({
        title: '提示',
        message: 'AI算力不足，请充值',
        confirmButtonText: '去充值',
        cancelButtonText: '取消',
      }).then(res => {
        if (res === 'confirm') {
          this.showAiPopup=false
          if(state) {
            if (len) this.dataList[len - 1].aiResults = []
            if (this.dataList[len - 1].backText) this.setBack(len - 1)
          }
          this.routerAiMoney()
        }
        console.log(res)
      }).catch(err => {
        if (state && err === 'cancel') {
          this.showAiPopup=false
          if (this.dataList[len - 1].backText) this.setBack(len - 1)
          if (len) this.dataList[len - 1].aiResults = []
        }
        console.log(err);
      });
    },
    aiAgain(){
      if (!this.aiRemaining) {
        this.aiConfirm()
        return
      }
      this.aiResults.push({
        id:new Date().getTime(),
        text:'',
        aipending:false,
        param:this.aiParam,
      })
      this.initWebSocket();
    },
    clearAIText(index){
      this.dataList[index].content=''
    },
    setBack(index){
      this.dataList[index].content=this.dataList[index].backText;
      this.dataList[index].showBack=false
      this.dataList[index].disabled=false;
    },
    oversize(){
      vant.Notify({
        type:'warning',
        message: `视频文件大小不能超过 ${this.maxSize} MB，请压缩后重新上传`
      });
    },  
    getKey(item, index) {
      let key = '';

      if (item.type === 'text' ||item.type === 'aitext'|| item.type === 'moment') {
        key = item._key_;
      } else if (item.type === 'image' || item.type === 'video') {
        key = item.url;
      } else if (item.type === 'audio') {
        key = item.url || item.serverId || item.localId;
      }

      return key;
    },
    // 排序
    sort(type, index) {
      let item = this.dataList.splice(index, 1)[0];

      if (type === 'down') {
        this.dataList.splice(index + 1, 0, item);
      } else if (type === 'up') {
        this.dataList.splice(index - 1, 0, item);
      }
    },
    // 删除一项
    dele(index) {
      this.dataList.splice(index, 1);
    },
    addAiText(){
      this.dataList.push({
        type: 'aitext',
        aiResults:[],
        content: '',
        _key_: new Date().getTime(),
      });
    },
    // 增加文本
    addText() {
      this.dataList.push({
        type: 'text',
        content: '',
        _key_: new Date().getTime(),
      });
    },
    // 增加图片
    async addImg_H5(res, detail) {
      // 前置校验
      const files = Array.isArray(res) ? res.map(item => item.file) : [res.file];
      console.log('H5 图片上传 - 开始', files);
      
      const isValid = await this.handleBeforeUpload(files, 'image');
      console.log('H5 图片上传 - 校验结果:', isValid);

      if (!isValid) {
        console.warn('H5 图片上传 - 校验失败，已返回');
        return;
      }
      
      // 如果有建议的文件名，创建新的 File 对象
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file._suggestedName) {
          console.log('H5 图片上传 - 创建新文件对象:', file._suggestedName);
          const newFile = new File([file], file._suggestedName, { type: file.type || 'image/jpeg' });
          
          // 保留特殊属性
          if (file._detectedType) {
            newFile._detectedType = file._detectedType;
          }
          if (file._suggestedName) {
            newFile._suggestedName = file._suggestedName;
          }
          
          files[i] = newFile;
        }
      }
      
      console.log('H5 图片上传 - 开始显示加载框');
      vant.Toast.loading({
        message: '上传中...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true,
        duration: 0,
      });

      let opts = Array.prototype.map.call(files, file => {
        console.log('H5 图片上传 - 准备上传文件:', file.name);
        return {
          platform: 'h5',
          options: {
            file: file,
            config: {
              image: {
                compress: false,
              },
            },
          },
        };
      });
      try {
        console.log('H5 图片上传 - 调用 OSS uploadFiles');
        let ret = await xgjzt.oss.uploadFiles(opts);
        console.log('H5 图片上传成功:', ret);
        this.dataList = this.dataList.concat(ret);
        vant.Toast.clear();
        vant.Toast('上传完成');
      } catch (error) {
        console.error('H5 图片上传失败:', error);
        vant.Toast.clear();
        vant.Toast(`上传失败: ${error.message}`);
      }
    },
    // 增加图片 -> 云校app环境下，调用原生app的能力
    async addImg() {
      let files = await app.sdk.chooseImage({
        max: 9,
        maxDuration: this.maxDuration,
      });
      
      // 前置校验
      const isValid = await this.handleBeforeUpload(files, 'image');
      if (!isValid) {
        return;
      }
      
      // 如果有建议的文件名，创建新的 File 对象
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file._suggestedName) {
          console.log('云校App 图片上传 - 创建新文件对象:', file._suggestedName);
          const newFile = new File([file], file._suggestedName, { type: file.type || 'image/jpeg' });
          
          // 保留特殊属性
          if (file._detectedType) {
            newFile._detectedType = file._detectedType;
          }
          if (file._suggestedName) {
            newFile._suggestedName = file._suggestedName;
          }
          
          files[i] = newFile;
        }
      }
      
      let opts = Array.prototype.map.call(files, file => {
        console.log('云校App 图片上传 - 准备上传文件:', file.name);
        return {
          platform: 'xgj',
          options: {
            file: file,
            config: {
              image: {
                compress: false,
              },
            },
          },
        };
      });
      vant.Toast.loading({
        message: '上传中...',
        overlay: true,
        duration: 0,
      });
      try {
        let ret = await xgjzt.oss.uploadFiles(opts);
        this.dataList = this.dataList.concat(ret);
        vant.Toast.clear();
        vant.Toast('上传完成');
      } catch (error) {
        console.error('云校App 图片上传失败:', error);
        vant.Toast.clear();
        vant.Toast(`上传失败: ${error.message}`);
      }
    },
    //预览图片
    previewImg(item) {
      
    },
    // 增加视频 -> H5能力
    async addVideo_H5(res, detail) {
      let files;
      if (Array.isArray(res)) {
        files = res.map(item => item.file);
      } else {
        files = [res.file];
      }
      
      // 前置校验 - 先校验，不显示加载框
      const isValid = await this.handleBeforeUpload(files, 'video');
      if (!isValid) {
        return;
      }

      // 校验通过后再显示加载框
      const toastInstance = vant.Toast.loading({
        message: '上传中...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true,
        duration: 0,
        className: 'mult-input-loading',
      });

      // 如果有建议的文件名，创建新的 File 对象
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file._suggestedName) {
          console.log('H5 视频上传 - 创建新文件对象:', file._suggestedName);
          const newFile = new File([file], file._suggestedName, { type: file.type || 'video/mp4' });
          
          // 保留特殊属性
          if (file._detectedType) {
            newFile._detectedType = file._detectedType;
          }
          if (file._suggestedName) {
            newFile._suggestedName = file._suggestedName;
          }
          
          files[i] = newFile;
        }
      }

      const progeressMessageList = new Array(files.length);

      function changeMessage() {
        toastInstance.message = progeressMessageList.length == 1 ? `${progeressMessageList[0]}%` : 
          progeressMessageList.map((item, index)=> `第${index + 1}个视频：${item}%`).join('\n');
        toastInstance.message = '正在上传...\n\n' + toastInstance.message;
      }

      let opts = Array.prototype.map.call(files, (file,index) => {
        console.log('H5 视频上传 - 文件:', file.name, '建议名称:', file._suggestedName);
        return {
          platform: 'h5',
          options: {
            file: file,
            config: {
              image: {
                compress: false,
              },
            },
            progress: p => {
              progeressMessageList[index] = p < 10 ? '  ' + p : p < 100 ? ' ' + p : p;
              changeMessage();
            },
          },
        };
      });
      try {
        let ret = await xgjzt.oss.uploadFiles(opts);
        this.dataList = this.dataList.concat(ret);
        vant.Toast.clear();
      } catch (error) {
        console.error('H5 视频上传失败:', error);
        vant.Toast.clear();
        vant.Toast(`上传失败: ${error.message}`);
      }
    },
    // 增加视频 -> 云校app环境下，调用原生app的能力
    async addVideo() {
      let files = await app.sdk.chooseVideo({
        max: 9,
        maxDuration: this.maxDuration,
        maxSize: this.maxSize,
      });
      
      // 前置校验
      const isValid = await this.handleBeforeUpload(files, 'video');
      if (!isValid) {
        return;
      }
      
      // 如果有建议的文件名，创建新的 File 对象
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file._suggestedName) {
          console.log('云校App 视频上传 - 创建新文件对象:', file._suggestedName);
          const newFile = new File([file], file._suggestedName, { type: file.type || 'video/mp4' });
          
          // 保留特殊属性
          if (file._detectedType) {
            newFile._detectedType = file._detectedType;
          }
          if (file._suggestedName) {
            newFile._suggestedName = file._suggestedName;
          }
          
          files[i] = newFile;
        }
      }
      
      const toastInstance = vant.Toast.loading({
        message: '上传中...',
        overlay: true,
        duration: 0,
      });

      const progeressMessageList = new Array(files.length);

      function changeMessage() {
        toastInstance.message = progeressMessageList.length == 1 ? `${progeressMessageList[0]}%` : 
          progeressMessageList.map((item, index)=> `第${index + 1}个视频：${item}%`).join('\n');
        toastInstance.message = '正在上传...\n\n' + toastInstance.message;
      }
      let opts = Array.prototype.map.call(files, (file,index) => {
        console.log('云校App 视频上传 - 文件:', file.name, '建议名称:', file._suggestedName);
        return {
          platform: 'xgj',
          options: {
            file: file,
            config: {
              image: {
                compress: false,
              },
            },
            progress: p => {
              progeressMessageList[index] = p < 10 ? '  ' + p : p < 100 ? ' ' + p : p;
              changeMessage();
            },
          },
        };
      });

      try {
        let ret = await xgjzt.oss.uploadFiles(opts);
        this.dataList = this.dataList.concat(ret);
        vant.Toast.clear();
        vant.Toast('上传完成');
      } catch (error) {
        console.error('云校App 视频上传失败:', error);
        vant.Toast.clear();
        vant.Toast(`上传失败: ${error.message}`);
      }
    },
   
    // getImgThumbUrl(item) {
    //   return `${item.url}?x-oss-process=image/resize,m_mfit,w_500,h_500/quality,Q_50`;
    // },
    // 获取视频封面图
    getVideoThumbUrl(item) {
      return item.thumburl || `${item.url}?x-oss-process=video/snapshot,t_1,f_jpg,w_1000,ar_auto`;
    },
    // 增加录音
    async addVioce() {
      if (app.base.env == 'browser') {
        vant.Toast({
          icon: 'fail',
          message: '暂不支持,请下载APP或前往公众号使用',
        });
      } else {
        let res = await app.module.voice.record();
        this.dataList = this.dataList.concat(res);
      }
    },
    updateDataList(arr) {
      this.dataList = this.dataList.concat(arr);
    },
    overlayClick(){
    // console.log('遮罩');
    },
    
    /**
     * 上传前校验 - 检查文件数量、类型等
     * @param {File|File[]} files 
     * @param {string} expectedType 期望类型 'image' 或 'video'
     * @returns {boolean} 是否通过校验
     */
    async handleBeforeUpload(files, expectedType = 'image') {
      const fileArray = Array.isArray(files) ? files : [files];
      const currentCount = this.dataList.length;
      const totalCount = currentCount + fileArray.length;
      
      // 检查总数量限制
      if (totalCount > this.imgMax) {
        vant.Toast(`单次最多上传${this.imgMax}个文件，当前已有${currentCount}个`);
        return false;
      }
      
      // 检查苹果设备单次选择限制
      if (this.isAppleDevice && this.isAppleDevice() && fileArray.length > 9) {
        vant.Toast('苹果设备最多只能选择9个文件');
        return false;
      }
      
      // 逐个检测文件类型
      for (const file of fileArray) {
        // 传入expectedType以便进行特殊的vsg_output验证
        const result = await detectFileType(file, expectedType);
        const { isImage, isVideo, errorMsg } = result;
        
        // 如果检测返回错误信息，直接提示
        if (errorMsg) {
          // 获取文件后缀
          const fileExtension = file.name.split('.').pop();
          const suffix = fileExtension && fileExtension !== file.name ? `.${fileExtension}` : '无后缀';
          vant.Toast(`${suffix} - ${errorMsg}`);
          return false;
        }
        
        // 最终类型判断
        const isValidType = (expectedType === 'image' && isImage) || 
                           (expectedType === 'video' && isVideo);
        
        if (!isValidType) {
          vant.Toast(`文件"${file.name}"类型不符合要求`);
          return false;
        }
        
        console.log('文件检测通过:', file.name, '类型:', expectedType);
      }
      
      return true;
    }
  },
  mounted(){
  let _this=this;
      // 监听文档的点击事件
    document.addEventListener('click', function(event) {

      var targetElement = event.target; // 获取触发事件的元素
      
      // 检查触发事件的元素是否为目标div或其子元素
      if (!targetElement.closest('.van-overlay')&&!targetElement.closest('#nl-id')&&
      !targetElement.closest('#manner-id')&&
      !targetElement.closest('#count-id')&&!targetElement.closest('#ai-param-id')&&!targetElement.closest('#ai-more')&&_this.showIdea&&(!_this.shownl&&!_this.showmanner&&!_this.showcount)) {
        // 点击事件发生在目标div以外的处理逻辑
        _this.openIdea()
      }
    });

    // 监听文档的触摸事件
    document.addEventListener('touchstart', function(event) {
      var targetElement = event.target; // 获取触发事件的元素

      // 检查触发事件的元素是否为目标div或其子元素
      if (!targetElement.closest('.van-overlay')&&!targetElement.closest('#nl-id')&&
      !targetElement.closest('#manner-id')&&
      !targetElement.closest('#count-id')&&!targetElement.closest('#ai-param-id')&&!targetElement.closest('#ai-more')&&_this.showIdea&&(!_this.shownl&&!_this.showmanner&&!_this.showcount)) {
        // 触摸事件发生在目标div以外的处理逻辑
        _this.openIdea()
      }
    });
  },
  created() {
    // 获取app版本号
    if (app.base.env == 'xgj') {
      app.sdk.getAppVersion().then(version => {
        console.log('app 版本号 ....');
        console.log(version);
        this.xgj_version = version.versionName;
      });
    }
    
    this.aiParam=this.getAiParam();
    if(this.aiParam.dict.emoji==='添加'){
      this.selectAIParamActives=['emoji']
    }else{
      this.selectAIParamActives=[]
    }
    this.aiParam.message=''
    this.setAiParam();
    // console.log(_xgjapp_);
  },
  beforeDestroy(){
    this.closeAiServer();
  },
  watch: {
    // 双向绑定的关键
    list: {
      immediate: true,
      handler: function (nv, ov) {
        if (nv !== ov) {
          // 目的加一个唯一的key
          this.list.forEach((item, index) => {
            if ((item.type == 'text' ||item.type == 'aitext'  || item.type == 'moment') && item._key_) {
              item._key_ = `${index}-${new Date().getTime()}`;
            }
            // console.log(item.aiResults,'airesulkt')
            if(!item.aiResults||!item.aiResults.length){
              item.aiResults=[]
            }
            // item.showPopover=false;
            // item.
          });
          this.dataList = this.list
        }
      },
    },
    dataList: {
      deep: true,
      handler: function (nv, ov) {
        this.$emit('change', this.dataList);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-popup{
  background-color:#F7F8FA;
  overflow-y:hidden;
  overflow:hidden;
  .header{
    height:56px;
    background-color:#F7F8FA;
    z-index:10;
    width:100%;
    position:relative;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius: 16px 16px 0 0;

    .title{
      font-size: 18px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #303133;
    }
    .close{
      position: absolute;
      right: 16px;
      width: 16px;
      height: 16px;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .aiMessage {
    width: calc(100% - 32px);
    height: 36px;
    background: #FFFBE8;
    border-radius: 8px;
    font-size: 13px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #ED6A0C;
    text-align: center;
    margin: 0 auto 0;
    line-height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .content-list{
    height:calc(100% - 108px - env(safe-area-inset-bottom));
    overflow:hidden;
    overflow-y:auto;
    transition: all 0.5s;
    margin-top:0px;
    padding-top:0px;

    .content-item{
      width: calc(100% - 32px);
      transition:all 0.5s;
      margin:0 auto;
      margin-top: 8px;
      margin-bottom: 8px;
      padding-top:16px;
      padding-bottom:16px;
      min-height: 200px;
      background: #FFFFFF;
      box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
      border-radius: 8px;
      display:flex;
      flex-direction:column;
      .content-header{
        display:flex;
        justify-content:space-between;
        align-items:center;
        padding-left:16px;
        padding-right:16px;
        .icon{
          width:24px;
          height:24px;
          img{
            width:24px;
            height:24px;
          }
        }
        .num{
          height: 25px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          color: #DCDFE5;
          line-height: 25px;
        }
      }
      .content-text{
        margin:0 auto;
        margin-top:13px;
        width: calc(100% - 32px);
        .van-cell{
          padding:0px
        }
        /deep/ textarea{
          white-space:pre-wrap;
        }
      }
      .content-tool{
        display:flex;
        align-items:center;
        justify-content:space-between;
        width: calc(100% - 32px);
        margin:0 auto;
        margin-top:21px;
        height:32px;
        .stop{
          margin: 0 auto;
          display: flex;
          align-items: center;
          width: 80px;
          border-radius:16px;
          justify-content: space-around;
          padding: 7px 12px 7px 12px;
          background-color: rgba(var(--c1-rgb),0.1);
          .vxm-icon{
            font-size:15px;
            color:var(--c1);
          }
          // img{
          //   width:15px;
          //   height:15px;
          // }
        }
        .clear{
          width:32px;
          height:32px;
          border-radius:20px;
          background: #FFFFFF;
          box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.1);
          display:flex;
          align-items:center;
          justify-content:center;
          img{
            width:16px;
            height:16px;
          }
        }
        .select-use{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: var(--c1);
        }
      }
    }
    .ai-param-s{
      padding-left:4px;
      padding-right:16px;
      opacity: 0;
      overflow: hidden;
      transition: all 0.5s;
      bottom: 52px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e3e7ee;
      width: 100%;
      height: 0px;
    }
  }
  .content-list-active {
    height:calc(100% - 144px - env(safe-area-inset-bottom));
  }
  .ai-param{
    padding-left:4px;
    padding-right:16px;
    opacity: 0;
    overflow: hidden;
    transition: all 0.5s;
    position: fixed;
    bottom: calc(52px + env(safe-area-inset-bottom));
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e3e7ee;
    width: 100%;
    height: 0px;
    background-color: #fff;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    .item{
      width: 77px;
      height: 32px;
      margin-left:12px;
      border-radius: 8px;
      background-color: #f7f8fa;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      .van-icon{
        transform: rotate(90deg);
        color:#969799;
        font-size: 12px;
        transition: all 0.5s;
      }

    }
    .select-active{

      /deep/ .van-icon{
        transform: rotate(-90deg);
      }
    } 

    .select-active-banner{
      background-color: var(--c1);
      color: #fff;
      /deep/ .van-icon{
        color:#fff;
      }
    }
    .ai-nl{

    }
    .ai-manner{}
    .ai-count{}
    .ai-emoji{}

  }
  .ai-show-param{

  }
  .ai-tool{
    position: fixed;
    bottom: env(safe-area-inset-bottom);
    width: 100%;
    background: #fff;
    height:52px;
    padding:6px 16px 6px 16px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    width:100%;
    .more{
      width:36%;
      height:40px;
      border-radius:8px;
      padding:8px 22px 8px 22px;
      border:1px solid #ecEdF0;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.3s;
      .vxm-icon{
        font-size:24px;
        color:var(--c1);
      }
      // img{
      //   width:24px;
      //   height:24px;
      // }
      span{
        margin-left:4px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #323233;
        transition: all 0.3s;
      }
    }
    .active{
      transition: all 0.3s;
      border:1px solid var(--c1);
      span{
        color:var(--c1);
        transition: all 0.3s;
      }
    }
    .product{
      border-radius:8px;
      width:60%;
    }
    
  }
}

.mult-input {
  padding: calc(var(--gap) * 0) 0;
  width: 100%;
  .mult-list {
    padding-top: calc(var(--gap) * 0);
    /deep/ .van-popover{
      top:210px;
    }
    .mult-item {
      position: relative;
      padding: calc(var(--gap) *6) 0;
      .van-popover__wrapper{
        position: absolute;
        right: 0;
      }
      .item-tool{
        width:24px;
        height:16px;
        position:absolute;
        right:0px;
        z-index:2;
        background-color:rgba(0,0,0,0.2);
        // opacity:0.2;
        text-align:center;
        border-top-right-radius: 5px;
        border-bottom-left-radius: 5px;
        background-image:url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00129.png);
        background-size:100% 100%;
        // img{
        //   width:16px;
        //   height:16px;
        //   margin:0 auto;
        //   z-index:3;
        // }
      }
      .mu-icons {
        .vxm-icon {
          position: absolute;
          top: calc(var(--w) * -3);
          font-size: calc(var(--w) * 20);
          z-index: 2;
        }
        .mu-down {
          width:20px;
          left: 0;
          height:20px;
        }
        .mu-up {
          height:20px;
          width:20px;
          left: calc(var(--w) * 50);
        }
        .mu-del {
          height:20px;
          width:20px;
          right: 0;
        }
      }
      .aitext{
        padding-bottom: 30px;
        border-radius: 5px;
        position: relative;
        background: var(--g1);
        .text {
          min-height:160px;
          border-radius: 5px;
          background: var(--g1);
          padding-bottom:24px;
          ::v-deep .van-field__control {
            font-size: var(--fs-md);
            line-height: var(--lh-md);
          }
          /deep/ textarea{
            white-space:pre-wrap;
          }
        } 
        .tool{
          display: flex;
          justify-content: space-between;
          position: absolute;
          bottom: 14px;
          align-items: center;
          width: 100%;
          padding-left: 16px;
          padding-right: 16px;
          .left{
            display:flex;
            .clear{
              font-size: 12px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              color: var(--c1);
              line-height: 14px;
            }
            .set-back{
              font-size: 12px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              color: var(--c1);
              line-height: 14px;
              margin-left:16px;
            }
          }
          
          .ai{
            display:flex;
            .pbjc{
              width:80px;
              height:28px;
              border-radius:6px;
              border:1px solid var(--c1);
              text-align:center;
              line-height:28px;
              color:var(--c1);
              margin-right:12px;
            }
            .aiwhrite{
              width: 57px;
              height: 28px;
              background: var(--c1);
              border-radius: 6px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              text-align: center;
              line-height: 28px;
            }
          }
          
        }
      }
      .text {
        border-radius: 5px;
        background: var(--g1);
        ::v-deep .van-field__control {
          font-size: var(--fs-md);
          line-height: var(--lh-md);
        }
      }
      .img {
        text-align: center;
        background: var(--g1);
        border-radius: 5px;
        overflow: hidden;
      }
      .video {
        position: relative;
        text-align: center;
        background: var(--g1);
        border-radius: 5px;
        overflow: hidden;
        width: 100%;
        height: 0;
        padding-top: 56.25%;
        .vimg {
          position: absolute;
          width: 100%;
          top: 0;
          bottom: 0;
        }
        .pay-icon-warp {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0, 0, 0, 0.3);
          .to-play-icon {
            width: calc(var(--gap) * 40);
            height: calc(var(--gap) * 40);
          }
        }
      }
      .video-default {
        border-radius: 5px;
        background: var(--g1);
        text-align: center;
        padding: calc(var(--gap) * 70) 0;
        .txt {
          font-size:var(--fs-lg);
          line-height:var(--lh-lg);
          color: var(--c1);
          .van-loading {
            margin-right: calc(var(--gap) * 8);
          }
        }
        .desc {
          margin-top: calc(var(--gap) * 12);
          font-size:var(--fs-md);
          line-height:var(--lh-md);
          color: var(--g6);
        }
      }
    }
  }
  .toolbar {
    display: flex;
    padding-top: calc(var(--gap) * 16);
    .tool {
      position: relative;
      text-align: center;
      margin-right: calc(var(--gap) * 16);
      img{
        width:58px;
        height:19px;
        position:absolute;
        top:-18px;
      }
      .up-btn {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        opacity: 0;
      }
      .vxm-icon {
        display: inline-block;
        vertical-align: middle;
        font-size: calc(var(--w) * 50);
      }
      .text {
        vertical-align: middle;
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        padding-top: calc(var(--gap) * 8);
        font-weight: 400;
        color: var(--g7);
      }
    }
  }
}
</style>


<style>
  .mult-input-loading.van-toast {
    width: 140px;
  }
</style>